function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

import * as React from "react";

var _ref = /*#__PURE__*/React.createElement("path", {
  d: "M27 16.067C27 9.955 22.075 5 16 5S5 9.955 5 16.067C5 21.591 9.023 26.17 14.281 27v-7.734h-2.793v-3.199h2.793V13.63c0-2.774 1.642-4.306 4.155-4.306 1.204 0 2.462.216 2.462.216v2.724h-1.387c-1.366 0-1.792.853-1.792 1.728v2.076h3.05l-.487 3.2h-2.563V27C22.977 26.17 27 21.591 27 16.067",
  stroke: "#000",
  strokeWidth: 1.6,
  fill: "none",
  fillRule: "evenodd",
  strokeLinejoin: "round"
});

function SvgUiFacebook32(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 32,
    height: 32,
    viewBox: "0 0 32 32"
  }, props), _ref);
}

export default SvgUiFacebook32;